import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DeviceAccessRequestGuard implements CanActivate {
  constructor(
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const deviceToken = route.queryParams['deviceToken'];

    if (!deviceToken) {
      // No deviceToken query param - redirect to login
      this.router.navigate(['/auth/login']);
      return false;
    }

    // Token exists - allow access (backend will validate the token when form is submitted)
    return true;
  }
}

